import React, { Component } from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'

const { RangePicker } = DatePicker

class FilterDateRangeV2 extends Component {
    state = {
        tempRange: [moment().subtract(14, 'days').startOf("day")],
        isPickerOpen: false,
    }
    _handleDateChange = (date, dateString) => {
        const [from, to] = dateString
        if (!from) this.setState({ tempRange: [] })

        const { field, onDatesChange, showTime } = this.props
        if (showTime) {
            onDatesChange(field, {
                from,
                to,
                date: { from: from.split(' ')[0], to: to.split(' ')[0] },
                time: { from: from.split(' ')[1], to: to.split(' ')[1] }
            })
        } else {
            onDatesChange(field, { from, to })
        }
    }

    _renderClassName = () => {
        const { className } = this.props
        const strClassName = className + ''

        const trimClassName = strClassName.trim()

        if (!trimClassName) {
            return 'FilterDateRange'
        }

        return `FilterDateRange ${trimClassName}`
    }

    disabledRangeDate = (current) => {
        const { tempRange, isPickerOpen } = this.state

        const [start, end] = tempRange || []

        if (!isPickerOpen) return false

        if (!start && !end) return false

        if (!start && end) {
            return current > end
        }

        if (start && !end) {

            const maxToDate = moment(start).add(6, 'months').endOf('day')
            return current < start || current > maxToDate
        }

        return false
    }

    handleCalendarChange = (dates) => {
        const { field, onDatesChange } = this.props
        const [from, to] = dates

        this.setState({ tempRange: dates })

        if (from && !to) {
            const fromStr = from.format("DD/MM/YYYY HH:mm")

            onDatesChange(field, {
                from: fromStr,
                to: '',
                date: { from: fromStr.split(' ')[0], to: '' },
                time: { from: fromStr.split(' ')[1], to: '' }
            })
            this.setState({ isPickerOpen: true })
        }
    }

    render() {
        const { heading, showTime, filters = {}, field, isClear = true, isDisableData = false } = this.props
        const { from, to } = { ...(filters.hasOwnProperty(field) ? filters[field] : {}) }
        const wrapperClass = this._renderClassName()
        const DATE_FORMAT = showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
        const fromDatetime = !!from ? moment(from, DATE_FORMAT) : from
        const toDatetime = !!to ? moment(to, DATE_FORMAT) : to
        const rangeValue = (!!from || !!to) ? [fromDatetime, toDatetime] : []
        const isShowValue = !!this.state.tempRange.length && !!this.state.tempRange[0] && !this.state.tempRange[1]

        return (
            <div className={wrapperClass}>
                {
                    heading &&
                    <div className='font-weight-500 mb-2'>{heading}</div>
                }

                <RangePicker
                    ranges={{
                        'Today': [moment().startOf('day'), moment().endOf('day')],
                        'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                    }}
                    format={DATE_FORMAT}
                    showTime={showTime ? {
                        hideDisabledOptions: true,
                        format: 'HH:mm',
                        defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
                    } : showTime}
                    {...((Object.keys(filters).length > 0 && !!from && !!to) ? { value: rangeValue } : {})}
                    style={{ width: '100%' }}
                    onChange={this._handleDateChange}
                    allowClear={isClear}
                    {...(isDisableData ? {
                        ...(this.state.isPickerOpen ? { disabledDate: this.disabledRangeDate } : {}),
                        onCalendarChange: this.handleCalendarChange,
                        ...(isShowValue ? { value: [this.state.tempRange[0], null] } : {}),
                        onOpenChange: open => this.setState({ isPickerOpen: !open }),
                    } : {})}
                />
            </div>
        )
    }
}

FilterDateRangeV2.propTypes = {
    heading: PropTypes.string,
    className: PropTypes.string,
    field: PropTypes.string.isRequired,
    onDatesChange: PropTypes.func.isRequired,
}

export default FilterDateRangeV2
